import { ConnectComponent } from '../_components/ConnectComponent'
import { LogInPresenter } from './LogIn.presenter'
import { LogInView } from './LogIn.view'

export const LogIn = ConnectComponent(LogInView, LogInPresenter)
